import React from "react";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import "./DoMoreBusinessBanner.css";
import Button from "components/Button/Button";

const DoMoreBusinessBanner = () => {
    return (
        <WidgetContainer stylesClass="domore">
            <div className="domore-business">
                <h2>
                    Do more for your business <br /> with PhonePe.
                </h2>
                <div className="domore-business__btn-container">
                    <Button
                        btnText="Get Started"
                        btnStyle="btnStyle"
                        pagePath="/business-solutions/"
                    />
                </div>
            </div>
        </WidgetContainer>
    );
};

export default DoMoreBusinessBanner;
